export const illustrations = [
    {
        id: "illustrations0",
        img: require('../assets/Gelosia.JPG'),
        link: "https://www.instagram.com/p/C4ROSXXicuF/?img_index=1",
    },
    {
        id: "illustrations1",
        img: require('../assets/Alpha.JPG'),
        link: "https://www.instagram.com/ates_tales/p/C2Ict97ipq7/?img_index=1",
    },
    {
        id: "illustrations2",
        img: require('../assets/Dog.png'),
        link: "https://www.instagram.com/p/CreXSjXIow7/?utm_source=ig_web_copy_link&igshid=MzRlODBiNWFlZA==",
    },
    {
        id: "illustrations3",
        img: require('../assets/Cruel.png'),
        link: "https://www.instagram.com/p/CleXluDopzx/?utm_source=ig_web_copy_link&igshid=MzRlODBiNWFlZA==",
    },
    {
        id: "illustrations4",
        img: require('../assets/Wardrope.png'),
        link: "https://www.instagram.com/p/Cfo_V5LoD7k/?utm_source=ig_web_copy_link&igshid=MzRlODBiNWFlZA==",
    },
    {
        id: "illustrations5",
        img: require('../assets/Skull.png'),
        link: "https://www.instagram.com/p/CYrMvogMw91/?utm_source=ig_web_copy_link&igshid=MzRlODBiNWFlZA==",
    },
    {
        id: "illustrations6",
        img: require('../assets/PigMan.png'),
        link: "https://www.instagram.com/p/CYmS7YtMCEq/?utm_source=ig_web_copy_link&igshid=MzRlODBiNWFlZA==",
    },
    {
        id: "illustrations7",
        img: require('../assets/Diablo.png'),
        link: "https://www.instagram.com/p/CQEzm08nUQ6/?utm_source=ig_web_copy_link&igshid=MzRlODBiNWFlZA==",
    },
    {
        id: "illustrations8",
        img: require('../assets/Panther&Roses.png'),
        link: "https://www.instagram.com/p/COYdQYaHYNx/?utm_source=ig_web_copy_link&igshid=MzRlODBiNWFlZA==",
    },
    {
        id: "illustrations9",
        img: require('../assets/Skull&Roses.png'),
        link: "https://www.instagram.com/p/COBkzxAH68X/?utm_source=ig_web_copy_link&igshid=MzRlODBiNWFlZA==",
    },
]